import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiCheckCircle, FiX, FiInfo, FiAlertCircle } from 'react-icons/fi';

const Toast = ({ toasts, removeToast }) => {
  useEffect(() => {
    toasts.forEach((toast) => {
      if (toast.autoClose) {
        const timer = setTimeout(() => {
          removeToast(toast.id);
        }, toast.duration || 3000);
        return () => clearTimeout(timer);
      }
    });
  }, [toasts, removeToast]);

  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return <FiCheckCircle className="text-green-500" size={20} />;
      case 'error':
        return <FiAlertCircle className="text-red-500" size={20} />;
      case 'info':
        return <FiInfo className="text-blue-500" size={20} />;
      default:
        return <FiCheckCircle className="text-green-500" size={20} />;
    }
  };

  const getBgColor = (type) => {
    switch (type) {
      case 'success':
        return 'bg-green-500/20 border-green-500/50';
      case 'error':
        return 'bg-red-500/20 border-red-500/50';
      case 'info':
        return 'bg-blue-500/20 border-blue-500/50';
      default:
        return 'bg-green-500/20 border-green-500/50';
    }
  };

  return (
    <div className="fixed top-4 right-4 z-[100] space-y-2 max-w-sm w-full px-4 sm:px-0">
      <AnimatePresence>
        {toasts.map((toast) => (
          <motion.div
            key={toast.id}
            initial={{ opacity: 0, x: 300, scale: 0.8, y: -20 }}
            animate={{ 
              opacity: 1, 
              x: 0, 
              scale: 1,
              y: 0,
              transition: {
                type: 'spring',
                damping: 15,
                stiffness: 400,
                mass: 0.5,
              }
            }}
            exit={{ 
              opacity: 0, 
              x: 300, 
              scale: 0.8,
              transition: {
                duration: 0.2,
                ease: 'easeIn'
              }
            }}
            whileHover={{ scale: 1.02 }}
            className={`${getBgColor(toast.type)} backdrop-blur-md rounded-xl p-4 sm:p-5 border shadow-2xl`}
          >
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 mt-0.5">
                {getIcon(toast.type)}
              </div>
              <div className="flex-1 min-w-0">
                {toast.title && (
                  <p className="text-white font-semibold text-sm mb-1">
                    {toast.title}
                  </p>
                )}
                <p className="text-white/90 text-sm">
                  {toast.message}
                </p>
              </div>
              <button
                onClick={() => removeToast(toast.id)}
                className="flex-shrink-0 text-white/60 hover:text-white transition-colors p-1"
              >
                <FiX size={18} />
              </button>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default Toast;
